<template>
  <div class="back-button-div">
    <a href="#" class="back-button" @click.prevent="back">
      <img class="chevron-left" src="@/assets/back_chevron_left.png" alt="Back Chevron Left" />
      <span>{{ backButtonText }}</span>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    back() {
      this.$emit('go-back')
    }
  },
  props: {
    backButtonText: String
  },
}
</script>

<style>
.chevron-left{
  margin-right: 4px;
}
.back-button-div {
  margin-top: 33px;
}
.back-button {
  text-align: left;
}
.back-button:hover{
  color: white;
}
</style>